import Limit from '../Models/Limit';
import DataGridRequest from './DataGridRequest';
export class LimitsRequest extends DataGridRequest<Limit> {
    Url = '/limits/api';
}
